import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async'; // VIP Zırhımız eklendi
import { supabase } from '../supabase';

function UrunDetay() {
  const { id } = useParams();
  const navigate = useNavigate();
  
  const [urun, setUrun] = useState(null);
  const [loading, setLoading] = useState(true);
  
  // Resim sırasını tutan asıl state
  const [seciliResimIndex, setSeciliResimIndex] = useState(0); 
  
  const sliderRef = useRef(null);

  // --- EFSANEVİ DOKUNMATİK KAYDIRMA (SWIPE) MOTORU ---
  const [dokunmaBaslangic, setDokunmaBaslangic] = useState(null);
  const [dokunmaBitis, setDokunmaBitis] = useState(null);
  const minKaydirmaMesafesi = 50; 

  const dokunmaBasladi = (e) => {
    setDokunmaBitis(null);
    setDokunmaBaslangic(e.targetTouches[0].clientX);
  };

  const dokunmaHareketEtti = (e) => {
    setDokunmaBitis(e.targetTouches[0].clientX);
  };

  const dokunmaBitti = () => {
    if (!dokunmaBaslangic || !dokunmaBitis || !urun || !urun.resimler) return;
    
    const mesafe = dokunmaBaslangic - dokunmaBitis;
    const solaKaydirildi = mesafe > minKaydirmaMesafesi;
    const sagaKaydirildi = mesafe < -minKaydirmaMesafesi;
    const toplamResim = urun.resimler.length; 

    if (solaKaydirildi) {
      setSeciliResimIndex((onceki) => (onceki === toplamResim - 1 ? 0 : onceki + 1));
    }
    if (sagaKaydirildi) {
      setSeciliResimIndex((onceki) => (onceki === 0 ? toplamResim - 1 : onceki - 1));
    }
  };
  // ----------------------------------------------------

  useEffect(() => {
    const urunGetir = async () => {
      try {
        const { data, error } = await supabase.from('urunler').select('*').eq('id', id).single();
        if (error) throw error;
        setUrun(data);
      } catch (error) { 
        console.error(error.message); 
      } finally { 
        setLoading(false); 
      }
    };
    urunGetir();
  }, [id]);

  useEffect(() => {
    if (urun && urun.baslik) {
      document.title = `${urun.baslik} | Demir Grup Ankara`;
    }
  }, [urun]);

  const kaydir = (yon) => {
    if (sliderRef.current) {
      const miktar = 200;
      sliderRef.current.scrollBy({ left: yon === 'sol' ? -miktar : miktar, behavior: 'smooth' });
    }
  };

  const whatsappSiparis = (urunAdi) => {
    const telefon = "905454167141"; 
    const mesaj = `Merhaba, web sitenizdeki "${urunAdi}" ürünü hakkında bilgi almak istiyorum.`;
    window.open(`https://wa.me/${telefon}?text=${encodeURIComponent(mesaj)}`, '_blank');
  };

  return (
    <div className="kamera-detay-page-new">
      
      {/* SİHİRLİ KOD: Helmet sadece ürün verisi geldikten sonra devreye girer */}
      {!loading && urun && (
        <Helmet>
          <title>{urun.baslik} | Demir Grup Ankara</title>
          <meta name="description" content={urun.aciklama ? urun.aciklama.substring(0, 150) + "..." : "Demir Grup güvencesiyle yüksek kaliteli sistemler."} />
          <link rel="canonical" href={`https://www.ddemirgrup.com.tr/urun/${id}`} />
          
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Product",
              "name": urun.baslik,
              "image": urun.resimler && urun.resimler.length > 0 ? urun.resimler[0] : "",
              "description": urun.aciklama,
              "brand": {
                "@type": "Brand",
                "name": "Demir Grup"
              }
            })}
          </script>
        </Helmet>
      )}

      <div className="detay-ust-bar">
        <button className="geri-btn" onClick={() => navigate(-1)}><span>←</span> Geri Dön</button>
      </div>

      {/* SİHİRLİ KOD: Loading içeri hapsedildi, karanlık VIP arka plan korundu! */}
      {loading ? (
        <div className="premium-loader-container">
          <div className="dg-spinner"></div>
          <div className="premium-loader-text">Ürün Verileri Alınıyor...</div>
        </div>
      ) : !urun ? (
        <div style={{paddingTop: '150px', textAlign: 'center', color: 'white'}}>Ürün bulunamadı!</div>
      ) : (
        <div className="detay-container-new">
          
          {/* SOL TARAF: RESİM BÖLÜMÜ */}
          <div className="detay-image-new">
              
            {/* Ana Resim ve Dokunmatik Motor */}
            <div 
              className="ana-resim-box"
              onTouchStart={dokunmaBasladi}
              onTouchMove={dokunmaHareketEtti}
              onTouchEnd={dokunmaBitti}
            >
              {urun.resimler && urun.resimler.length > 0 && (
                <img src={urun.resimler[seciliResimIndex]} alt={`${urun.baslik} Detay`} />
              )}
            </div>

            {/* Alt Küçük Resimler (Thumbnails) */}
            <div className="thumbnails-wrapper">
              <button className="slider-btn sol" onClick={() => kaydir('sol')}>&#10094;</button>
              <div className="detay-thumbnails" ref={sliderRef}>
                {urun.resimler && urun.resimler.map((url, idx) => (
                  <div 
                    key={idx} 
                    className={`thumbnail-item ${seciliResimIndex === idx ? 'active' : ''}`} 
                    onClick={() => setSeciliResimIndex(idx)}
                  >
                    <img src={url} alt="thumbnail" />
                  </div>
                ))}
              </div>
              <button className="slider-btn sag" onClick={() => kaydir('sag')}>&#10095;</button>
            </div>
          
          </div>

          {/* SAĞ TARAF: BİLGİ VE WHATSAPP BÖLÜMÜ */}
          <div className="detay-info-new">
            <div className="modal-header-line">Demir Grup | {urun.kategori}</div>
            <h1>{urun.baslik}</h1>
            <p className="detay-desc-new">{urun.aciklama}</p>
            
            <div className="detay-features-new">
              {urun.ozellikler && urun.ozellikler.split(',').map((o, i) => (
                <div key={i} className="feature-item-new"><span className="feature-icon">✓</span><span>{o.trim()}</span></div>
              ))}
            </div>

            <button className="whatsapp-btn-large-new" onClick={() => whatsappSiparis(urun.baslik)}>
              <span className="wa-icon">💬</span> WhatsApp'tan Bilgi Al
            </button>
            <p className="guvence-metni">🛡️ Profesyonel Malzeme ve Uzman İşçilik</p>
          </div>

        </div>
      )}
    </div>
  );
}

export default UrunDetay;